import { createFileRoute } from "@tanstack/react-router"

// Declared above `Route`: an arrow function is not hoisted, so referencing it
// from the `createFileRoute` call below would read it before initialisation.
const RouteComponent = () => {
  return <div>Hello /conversations/foo!</div>
}

export const Route = createFileRoute("/_chrome/conversations/foo")({
  component: RouteComponent,
})
